import React from 'react';
import { Modal, Spin } from 'antd';

const Loading = ({ loading }) => {
  return (
    <Modal
      visible={loading}
      footer={null}
      closable={false}
      centered
      zIndex={9999}
      // maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      modalRender={() => <div style={{ justifyContent: 'center', display: 'flex' }}><Spin size='large' /></div>}
      destroyOnClose
    />
  )
}

export default Loading;